import styled, { css, keyframes } from "styled-components";

interface SpinnerStyleProps {
    size: number;
}

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const SpinnerCircle = styled.div<SpinnerStyleProps>(
    ({ theme, size = 15 }) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        display: inline-block;
        width: ${size}px;
        height: ${size}px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid ${theme.palette.primary};
        border-radius: 50%;
        animation: ${spin} 1s linear infinite;
    `,
);
